import React from 'react';
import { FiBookOpen, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const courses = [
    { name: "B.TECH", desc: "Explore detailed information and top colleges offering B.Tech.", link: "/c_pages/B.Tech" },
    { name: "MBA", desc: "Explore detailed information and top colleges offering MBA.", link: "/c_pages/MBA" },
    { name: "M.TECH", desc: "Explore detailed information and top colleges offering M.Tech.", link: "/c_pages/M.Tech" },
    { name: "B.COM", desc: "Explore detailed information and top colleges offering B.Com.", link: "/c_pages/B.Com" },
    { name: "PH.D", desc: "Explore detailed information and top colleges offering Ph.D.", link: "/c_pages/PH.D" },
    { name: "M.SC", desc: "Explore detailed information and top colleges offering M.Sc.", link: "/c_pages/M.Sc" },
    { name: "BA", desc: "Explore detailed information and top colleges offering BA.", link: "/c_pages/BA" },
    { name: "BBA", desc: "Explore detailed information and top colleges offering BBA.", link: "/c_pages/BBA" },
];

const TopCoursesSection = () => {
    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
                {/* Outer Border Container */}
                <div className="border-2 border-orange-200 rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="mb-12">
                        <div className="inline-block px-4 py-1 rounded-full border border-orange-200 text-brand-orange text-xs font-bold uppercase tracking-widest mb-2">
                            Pick Your Path
                        </div>
                        <h2 className="text-3xl font-bold text-gray-800">
                            Top Courses <span className="text-brand-orange">2026</span>
                        </h2>
                        <div className="w-24 h-1 bg-brand-orange mt-2 rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {courses.map((course, index) => (
                            <Link to={course.link} key={index} className="group">
                                <div className="rounded-xl border border-gray-200 bg-white p-6 h-full flex flex-col justify-between transition-all duration-300 hover:shadow-xl hover:border-brand-orange hover:-translate-y-1 relative overflow-hidden">

                                    {/* Top Border Animation */}
                                    <div className="absolute top-0 left-0 w-0 h-1 bg-brand-orange group-hover:w-full transition-all duration-300 rounded-t-xl"></div>

                                    <div>
                                        <h3 className="text-xl font-bold mb-4 text-gray-800 group-hover:text-brand-orange transition">
                                            {course.name}
                                        </h3>
                                        <p className="text-sm text-gray-500 leading-relaxed mb-6">
                                            {course.desc}
                                        </p>
                                    </div>

                                    <div className="flex items-center justify-between mt-4 border-t border-gray-100 pt-4">
                                        <div className="p-2 rounded-full bg-orange-50 text-orange-500 group-hover:bg-brand-orange group-hover:text-white transition">
                                            <FiBookOpen size={16} />
                                        </div>
                                        <div className="p-2 rounded-full bg-orange-50 text-orange-500 group-hover:bg-brand-orange group-hover:text-white group-hover:translate-x-1 transition-all">
                                            <FiArrowRight size={16} />
                                        </div>
                                    </div>

                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TopCoursesSection;
